import { Helmet } from "react-helmet-async";

type SeoProps = {
  title: string;
  description?: string;
};

/**
 * Sets document title and meta description. Pass a short page title; "| NLHSC Events" is appended when missing.
 */
export function Seo({ title, description }: SeoProps) {
  const fullTitle = title.includes("| NLHSC Events")
    ? title
    : `${title} | NLHSC Events`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
    </Helmet>
  );
}
